import { combineReducers } from 'redux';
import approvalListReducer from './approvalsListReducer';
import appsListReducer from './intPortalReducers/appsListReducer';
import userReducer from './userReducer';
// import popUpReducer from './popUpReducer';
import { reducer as notifications } from 'react-notification-system-redux';
// import desktopClickAnalyticsReducer from './analyticsReducers/desktopClicksAnalytics';
// import desktopActivityAnalyticsReducer from './analyticsReducers/desktopActivityAnalytics';
import attaAnalyticsReducer from './analyticsReducers/attaAnalytics';
import mostActiverUsersAnalyticsReducer from './analyticsReducers/mostActiverUsersAnalytics';
import uniqueUserCountsAnaltyicsReducer from './analyticsReducers/uniqueUserCountsAnaltyics';
import userExceptionReducer from './admin/userException.reducer';
import userProfileReducer from './profile/profile.reducer';
import ApplicationReducer from './admin/application.reducer';
import ZoomLoggingReducer from './admin/zoom-logging.reducer';


let initialCountState = [
    { sysName: 'All', id: '0', amount: '0' },
    { sysName: 'Agile', id: '1', amount: '0' },
    { sysName: 'ISU', id: '2', amount: '0' },
    { sysName: 'SAP QN', id: '3', amount: '0' },
    { sysName: 'Coupa', id: '4', amount: '0' },
    { sysName: 'SAM', id: '5', amount: '0' },
    { sysName: 'HelpNow', id: '6', amount: '0' },
    { sysName: 'Trackwise', id: '7', amount: '0' },
    { sysName: 'Ivalua', id: '8', amount: '0' },
    { sysName: 'RCE ServiceNow', id: '9', amount: '0' },
    { sysName: 'Concur', id: '10', amount: '0' },
    { sysName: 'Neptune MT', id: '11', amount: '0' },
    { sysName: 'Fieldglass', id: '12', amount: '0' },
    { sysName: 'SmartRecruiters', id: '13', amount: '0' },
    { sysName: 'IT Timesheet', id: '14', amount: '0' },
    { sysName: 'Neptune PS', id: '15', amount: '0' },
    { sysName: 'My HCM', id: '16', amount: '0' },
    { sysName: 'MES', id: '17', amount: '0' },
    { sysName: 'Adobe Sign', id: '18', amount: '0' },
    { sysName: 'Archibus Moves', id: '19', amount: '0' },
    { sysName: 'Workday', id: '20', amount: '0' },
    { sysName: 'Purhcase Order', id: '21', amount: '0' },
    { sysName: 'Workforce', id: '22', amount: '0' },
    { sysName: 'Change Record', id: '23', amount: '0' },
    { sysName: 'Archibus Maint.', id: '24', amount: '0' }

];

let previousCountState = [
    { sysName: 'All', id: '0', amount: '0' },
    { sysName: 'Agile', id: '1', amount: '0' },
    { sysName: 'ISU', id: '2', amount: '0' },
    { sysName: 'SAP QN', id: '3', amount: '0' },
    { sysName: 'Coupa', id: '4', amount: '0' },
    { sysName: 'SAM', id: '5', amount: '0' },
    { sysName: 'HelpNow', id: '6', amount: '0' },
    { sysName: 'Trackwise', id: '7', amount: '0' },
    { sysName: 'Ivalua', id: '8', amount: '0' },
    { sysName: 'RCE ServiceNow', id: '9', amount: '0' },
    { sysName: 'Concur', id: '10', amount: '0' },
    { sysName: 'Neptune MT', id: '11', amount: '0' },
    { sysName: 'Fieldglass', id: '12', amount: '0' },
    { sysName: 'SmartRecruiters', id: '13', amount: '0' },
    { sysName: 'IT Timesheet', id: '14', amount: '0' },
    { sysName: 'Neptune PS', id: '15', amount: '0' },
    { sysName: 'My HCM', id: '16', amount: '0' },
    { sysName: 'MES', id: '17', amount: '0' },
    { sysName: 'Adobe Sign', id: '18', amount: '0' },
    { sysName: 'Archibus', id: '19', amount: '0' },
    { sysName: 'Workday', id: '20', amount: '0' },
    { sysName: 'Purhcase Order', id: '21', amount: '0' },
    { sysName: 'Workforce', id: '22', amount: '0' },
    { sysName: 'Change Record', id: '23', amount: '0' },
    { sysName: 'Archibus Maint.', id: '24', amount: '0' },
];

let previousCountStateTest = [
    { sysName: 'All', id: '0', amount: '12' },
    { sysName: 'Agile', id: '1', amount: '3' },
    { sysName: 'ISU', id: '2', amount: '1' },
    { sysName: 'SAP QN', id: '3', amount: '7' },
    { sysName: 'Coupa', id: '4', amount: '0' },
    { sysName: 'SAM', id: '5', amount: '0' },
    { sysName: 'HelpNow', id: '6', amount: '0' },
    { sysName: 'Trackwise', id: '7', amount: '0' },
    { sysName: 'Ivalua', id: '8', amount: '0' },
    { sysName: 'RCE ServiceNow', id: '9', amount: '0' },
    { sysName: 'Concur', id: '10', amount: '0' },
    { sysName: 'Neptune MT', id: '11', amount: '0' },
    { sysName: 'Fieldglass', id: '12', amount: '0' },
    { sysName: 'SmartRecruiters', id: '13', amount: '0' },
    { sysName: 'IT Timesheet', id: '14', amount: '0' },
];


//update previous system counts
const previousCountsReducer = (state = previousCountState, action) => {
    if (action.type == 'UPDATE_PREVIOUS_COUNTS') {
        //console.log('Updating previous Counts Reducer: ', action.payload);
        return action.payload;
    }

    return state; //default
};

//update amount of approvals for each system 
const systemsReducer = (state = initialCountState, action) => {
    switch (action.type) {
        case 'FETCH_APPROVALS':
            //let allCount = action.payload.approvals.length;
            let allCount = 0;
            let agileCount = 0;
            // let aribaCount = 0;
            let isuCount = 0;
            //let isuCount = Math.floor(Math.random() * 9); //for testing notification
            let sapQnCount = 0;
            let coupaCount = 0;
            let samCount = 0;
            let snowCount = 0;
            let trackwiseCount = 0;
            let ivaluaCount = 0;
            let rceCount = 0;
            let itTimeSheetCount = 0;
            let concurCount = 0;
            let neptuneMtCount = 0;
            let fieldglassCount = 0;
            let smartRecruitersCount = 0;
            let neptunePsCount = 0;
            let myHcmCount = 0;
            let mesCount = 0;
            let adobeSignCount = 0;
            let archibusCount = 0;
            let workdayCount = 0;
            let purchaseOrderCount = 0;
            let workforceCount = 0;
            let changeRecordCount = 0;
            let archibusMaintRecordCount = 0;

            for (let x of action.payload.approvals) {
                if (x.systemName === 'agile') {
                    agileCount++;
                } else if (x.systemName === 'isu') {
                    isuCount++;
                } else if (x.systemName === 'sap qn') {
                    sapQnCount++;
                } else if (x.systemName === 'coupa') {
                    coupaCount++;
                } else if (x.systemName === 'sam') {
                    samCount++;
                } else if (x.systemName === 'helpnow') {
                    snowCount++;
                } else if (x.systemName === 'trackwise') {
                    trackwiseCount++;
                } else if (x.systemName === 'ivalua') {
                    ivaluaCount++;
                } else if (x.systemName === 'rce servicenow') {
                    rceCount++;
                } else if (x.systemName === 'it timesheet') {
                    itTimeSheetCount++;
                } else if (x.systemName === 'concur') {
                    concurCount++;
                } else if (x.systemName === 'neptune mt') {
                    neptuneMtCount++;
                } else if (x.systemName === 'fieldglass') {
                    fieldglassCount++;
                } else if (x.systemName === 'smartrecruiters') {
                    smartRecruitersCount++;
                } else if (x.systemName === 'neptune ps') {
                    neptunePsCount++;
                } else if (x.systemName === 'my hcm') {
                    myHcmCount++;
                } else if (x.systemName === 'mes') {
                    mesCount++;
                } else if (x.systemName === 'adobe sign') {
                    adobeSignCount++;
                } else if (x.systemName === 'archibus moves') {
                    archibusCount++;
                } else if (x.systemName === 'workday') {
                    workdayCount++;
                } else if (x.systemName === 'purchase order') {
                    purchaseOrderCount++;
                } else if (x.systemName === 'workforce') {
                    workforceCount++;
                }
                else if (x.systemName === 'change record') {
                    changeRecordCount++;
                }
                else if (x.systemName === 'archibus maint.') {
                    archibusMaintRecordCount++;
                }
            }

            allCount = agileCount + isuCount
                + sapQnCount + coupaCount
                + samCount + snowCount
                + trackwiseCount + ivaluaCount
                + rceCount + concurCount
                + neptuneMtCount + fieldglassCount
                + smartRecruitersCount + itTimeSheetCount
                + neptunePsCount + myHcmCount
                + mesCount + adobeSignCount
                + archibusCount + workdayCount
                + purchaseOrderCount + workforceCount
                + archibusMaintRecordCount + changeRecordCount;

            return [
                { sysName: 'All', id: '0', amount: allCount },
                { sysName: 'Agile', id: '1', amount: agileCount },
                { sysName: 'ISU', id: '2', amount: isuCount },
                { sysName: 'SAP QN', id: '3', amount: sapQnCount },
                { sysName: 'Coupa', id: '4', amount: coupaCount },
                { sysName: 'SAM', id: '5', amount: samCount },
                { sysName: 'HelpNow', id: '6', amount: snowCount },
                { sysName: 'Trackwise', id: '7', amount: trackwiseCount },
                { sysName: 'Ivalua', id: '8', amount: ivaluaCount },
                { sysName: 'RCE ServiceNow', id: '9', amount: rceCount },
                { sysName: 'Concur', id: '10', amount: concurCount },
                { sysName: 'Neptune MT', id: '11', amount: neptuneMtCount },
                { sysName: 'Fieldglass', id: '12', amount: fieldglassCount },
                { sysName: 'SmartRecruiters', id: '13', amount: smartRecruitersCount },
                { sysName: 'IT Timesheet', id: '14', amount: itTimeSheetCount },
                { sysName: 'Neptune PS', id: '15', amount: neptunePsCount },
                { sysName: 'My HCM', id: '16', amount: myHcmCount },
                { sysName: 'MES', id: '17', amount: mesCount },
                { sysName: 'Adobe Sign', id: '18', amount: adobeSignCount },
                { sysName: 'Archibus Moves', id: '19', amount: archibusCount },
                { sysName: 'Workday', id: '20', amount: workdayCount },
                { sysName: 'Purchase Order', id: '21', amount: purchaseOrderCount },
                { sysName: 'Workforce', id: '22', amount: workforceCount },
                { sysName: 'Change Record', id: '23', amount: changeRecordCount },
                { sysName: 'Archibus Maint.', id: '24', amount: archibusMaintRecordCount }
            ];

        case 'TASK_CLEARED':
            let allCountUpdated = state[0].amount;
            let agileCountUpdated = state[1].amount;
            let isuCountUpdated = state[2].amount;
            let sapQnCountUpdated = state[3].amount;
            let coupaCountUpdated = state[4].amount;
            let samCountUpdated = state[5].amount;
            let snowCountUpdated = state[6].amount;
            let trackwiseCountUpdated = state[7].amount;
            let ivaluaCountUpdated = state[8].amount;
            let rceCountUpdated = state[9].amount;
            let concurUpdated = state[10].amount;
            let neptuneMtUpdated = state[11].amount;
            let fieldglassUpdated = state[12].amount;
            let smartRecruitersUpdated = state[13].amount;
            let itTimesheetUpdated = state[14].amount;
            let neptunePsUpdated = state[15].amount;
            let myHcmUpdated = state[16].amount;
            let mesUpdated = state[17].amount;
            let adobeSignUpdated = state[18].amount;
            let archibusUpdated = state[19].amount;
            let workdayUpdated = state[20].amount;
            let purchaseOrderUpdated = state[21].amount;
            let workforceUpdated = state[22].amount;
            let changeRecordUpdated = state[23].amount;
            let archibusMaintRecordUpdated = state[24].amount;

            //subtract 1 from all count
            allCountUpdated = allCountUpdated - 1;

            //subtract 1  form specific system count
            switch (action.payload.systemName) {
                case 'isu':
                    isuCountUpdated = isuCountUpdated - 1;
                    break;
                case 'agile':
                    agileCountUpdated = agileCountUpdated - 1;
                    break;
                case 'sap qn':
                    sapQnCountUpdated = sapQnCountUpdated - 1;
                    break;
                case 'coupa':
                    coupaCountUpdated = coupaCountUpdated - 1;
                    break;
                case 'sam':
                    samCountUpdated = samCountUpdated - 1;
                    break;
                case 'helpnow':
                    snowCountUpdated = snowCountUpdated - 1;
                    break;
                case 'trackwise':
                    trackwiseCountUpdated = trackwiseCountUpdated - 1;
                    break;
                case 'ivalua':
                    ivaluaCountUpdated = ivaluaCountUpdated - 1;
                    break;
                case 'rce servicenow':
                    rceCountUpdated = rceCountUpdated - 1;
                    break;
                case 'concur':
                    concurUpdated = concurUpdated - 1;
                    break;
                case 'neptune mt':
                    neptuneMtUpdated = neptuneMtUpdated - 1;
                    break;
                case 'fieldglass':
                    fieldglassUpdated = fieldglassUpdated - 1;
                    break;
                case 'smartrecruiters':
                    smartRecruitersUpdated = smartRecruitersUpdated - 1;
                    break;
                case 'it timesheet':
                    itTimesheetUpdated = itTimesheetUpdated - 1;
                    break;
                case 'neptune ps':
                    neptunePsUpdated = neptunePsUpdated - 1;
                    break;
                case 'my hcm':
                    myHcmUpdated = myHcmUpdated - 1;
                    break;
                case 'mes':
                    mesUpdated = mesUpdated - 1;
                    break;
                case 'adobe sign':
                    adobeSignUpdated = adobeSignUpdated - 1;
                    break;
                case 'archibus moves':
                    archibusUpdated = archibusUpdated - 1;
                    break;
                case 'workday':
                    workdayUpdated = workdayUpdated - 1;
                    break;
                case 'purchase order':
                    purchaseOrderUpdated = purchaseOrderUpdated - 1;
                    break;
                case 'workforce':
                    workforceUpdated = workforceUpdated - 1;
                    break;
                case 'change record':
                    changeRecordUpdated = changeRecordUpdated - 1;
                    break;
                case 'Archibus Maint.':
                    archibusMaintRecordUpdated = archibusMaintRecordUpdated - 1;
                    break;
                default:
                    break;
            }
            return [
                { sysName: 'All', id: '0', amount: allCountUpdated },
                { sysName: 'Agile', id: '1', amount: agileCountUpdated },
                { sysName: 'ISU', id: '2', amount: isuCountUpdated },
                { sysName: 'SAP QN', id: '3', amount: sapQnCountUpdated },
                { sysName: 'Coupa', id: '4', amount: coupaCountUpdated },
                { sysName: 'SAM', id: '5', amount: samCountUpdated },
                { sysName: 'HelpNow', id: '6', amount: snowCountUpdated },
                { sysName: 'Trackwise', id: '7', amount: trackwiseCountUpdated },
                { sysName: 'Ivalua', id: '8', amount: ivaluaCountUpdated },
                { sysName: 'RCE ServiceNow', id: '9', amount: rceCountUpdated },
                { sysName: 'Concur', id: '10', amount: concurUpdated },
                { sysName: 'Neptune MT', id: '11', amount: neptuneMtUpdated },
                { sysName: 'Fieldglass', id: '12', amount: fieldglassUpdated },
                { sysName: 'SmartRecruiters', id: '13', amount: smartRecruitersUpdated },
                { sysName: 'IT Timesheet', id: '14', amount: itTimesheetUpdated },
                { sysName: 'Neptune PS', id: '15', amount: neptunePsUpdated },
                { sysName: 'My HCM', id: '16', amount: myHcmUpdated },
                { sysName: 'MES', id: '17', amount: mesUpdated },
                { sysName: 'Adobe Sign', id: '18', amount: adobeSignUpdated },
                { sysName: 'Archibus Moves', id: '19', amount: archibusUpdated },
                { sysName: 'Workday', id: '20', amount: workdayUpdated },
                { sysName: 'Purchase Order', id: '21', amount: purchaseOrderUpdated },
                { sysName: 'Workforce', id: '22', amount: workforceUpdated },
                { sysName: 'Change Record', id: '23', amount: changeRecordUpdated },
                { sysName: 'Archibus Maint.', id: '24', amount: archibusMaintRecordUpdated }
            ];
        default:
            return state;
    }
};

//update selected system 
const selectedSystemReducer = (selectedSystem = { 'sysName': 'All', 'id': '0', 'amount': '0' }, action) => {
    // eslint-disable-next-line
    if (action.type == 'SYSTEM_SELECTED') {
        // console.log(`Selected System reducer: ${JSON.stringify(action.payload)}`);
        return action.payload;
    }

    return selectedSystem;
};

const selectedAttaFilterReducer = (selectedSystem = 'Last 30 Days', action) => {
    if (action.type === 'ATTA_FILTER_SELECTED') {
        return action.payload;
    }

    return selectedSystem;
}

const selectedMostActiveUserListReducer = (selectedSystem = 'Most Active', action) => {
    if (action.type === 'ACTIVE_USERS_LIST_FILTER_SELECTED') {
        return action.payload;
    }

    return selectedSystem;
}

const selectedUniqueUsersCountReducer = (selectedSystem = 'Monthly', action) => {
    if (action.type === 'UNIQUE_USERS_COUNT_FILTER_SELECTED') {
        return action.payload;
    }

    return selectedSystem;
}


const tokenCreatedReducer = (curToken = null, action) => {
    // eslint-disable-next-line
    if (action.type === 'TOKEN_CREATED') {
        //console.log(`Reducer payload: ${action.payload} `);
        return action.payload;
    }

    return curToken;
};

//update day filter
const dayFilterReducer = (curDayFilter = 'all', action) => {
    if (action.type === 'DAY_FILTER_SELECTED') {
        return action.payload;
    }

    return curDayFilter;
};

//add cleared id to clearedID list
const clearedListReducer = (state = [], action) => {
    //console.log("This is the reduceer: ", action);
    if (action.type === 'TASK_CLEARED') {
        return [...state, action.payload]; //creates new array with prrevious array contents and new entry
    }
    if (action.type === 'FETCH_APPROVALS') {
        //clear task cleared list
        return [];
    }
    return state;
};

const dataFetchCompleteReducer = (fetchComplete = 'false', action) => {
    if (action.type === 'FETCH_SENT') {
        return fetchComplete;
    }
    if (action.type === 'FETCH_COMPLETE') {
        return true;
    }
    return fetchComplete;
};

const activityGraphIsLoadingReducer = (isLoading = 'true', action) => {
    if (action.type === 'ACTIVITY_GRAPH_IS_LOADING') {
        return isLoading;
    }
    if (action.type === 'ACTIVITY_GRAPH_IS_READY') {
        return false;
    }
    return isLoading;
};

const clicksGraphIsLoadingReducer = (isLoading = 'true', action) => {
    if (action.type === 'CLICKS_GRAPH_IS_LOADING') {
        return isLoading;
    }
    if (action.type === 'CLICKS_GRAPH_IS_READY') {
        return false;
    }
    return isLoading;
};

const attaAnalyticsLoadingReducer = (isLoading = 'true', action) => {
    if (action.type === 'ATTA_GRAPH_IS_LOADING') {
        return isLoading;
    }
    if (action.type === 'ATTA_GRAPH_IS_READY') {
        return false;
    }
    return isLoading;
};

const mostActiveUsersListAnalyticsLoadingReducer = (isLoading = 'true', action) => {
    if (action.type === 'ACTIVE_USERS_LIST_IS_LOADING') {
        return isLoading;
    }
    if (action.type === 'ACTIVE_USERS_LIST_IS_READY') {
        return false;
    }
    return isLoading;
};

const uniqueUsersCountsAnalyticsLoadingReducer = (isLoading = 'true', action) => {
    if (action.type === 'UNIQUE_USER_COUNTS_IS_LOADING') {
        return isLoading;
    }
    if (action.type === 'UNIQUE_USERS_COUNTS_IS_READY') {
        return false;
    }
    return isLoading;
};

const isInitialPulledDataReducer = (isInitialData = 'false', action) => {
    if (action.type === 'TASK_CLEARED') {
        return false;
    }
    if (action.type === 'FETCH_COMPLETE') {
        return true;
    }
    return isInitialData;
};

const userAnalyticsAccessReducer = (isInitialData = true, action) => {
    // console.log('USER analytics payload', action.payload);
    switch (action.type) {
        case 'ANALYTICS_ACCESS':
            return action.payload;
        default:
            return isInitialData;
    }
};


export default combineReducers({
    systems: systemsReducer,
    previousSystemCounts: previousCountsReducer,
    selectedSystem: selectedSystemReducer,
    selectedAttaFilter: selectedAttaFilterReducer,
    selectedMostActiveUserFilter: selectedMostActiveUserListReducer,
    selectedUniqueUsersCountsFilter: selectedUniqueUsersCountReducer,
    curToken: tokenCreatedReducer,
    approvalList: approvalListReducer,
    user: userReducer,
    dayFilter: dayFilterReducer,
    clearedList: clearedListReducer,
    dataFetchComplete: dataFetchCompleteReducer,
    isInitialPulledData: isInitialPulledDataReducer,
    popUp: notifications,
    intPortalApps: appsListReducer,
    // desktopClickAnalytics: desktopClickAnalyticsReducer,
    // desktopActivityAnalytics: desktopActivityAnalyticsReducer,
    avgTimeToApproveAnalytics: attaAnalyticsReducer,
    mostActiveUsersList: mostActiverUsersAnalyticsReducer,
    uniqueUserCounts: uniqueUserCountsAnaltyicsReducer,
    analyticsAccess: userAnalyticsAccessReducer,
    activityGraphIsLoading: activityGraphIsLoadingReducer,
    clicksGraphIsLoading: clicksGraphIsLoadingReducer,
    attaGraphIsLoading: attaAnalyticsLoadingReducer,
    mostActiveUsersListIsLoading: mostActiveUsersListAnalyticsLoadingReducer,
    uniqueUserCountsIsLoading: uniqueUsersCountsAnalyticsLoadingReducer,
    userException: userExceptionReducer,
    userProfile: userProfileReducer,
    application: ApplicationReducer,
    zoomLogging: ZoomLoggingReducer,
});